import { images, pdfs, videos } from 'services/api';
import type { ChecklistItem } from 'services/api/checklistClient';
import { buildFlowPath } from './flowNavigation';

export type ChecklistLink = { url: string; download: boolean; newTab: boolean };

export const hasChecklistLink = (item: ChecklistItem): boolean =>
  Boolean(item.questionFlowName || item.externalUrl || (item.media && (item.media.storageKey || item.media.url)));

/** Match the cohort checklist: module first, external URL next, then signed media. */
export const resolveChecklistLink = async (item: ChecklistItem): Promise<ChecklistLink | null> => {
  if (item.questionFlowName) {
    return { url: buildFlowPath({ flowName: item.questionFlowName }), download: false, newTab: false };
  }
  if (item.externalUrl) return { url: item.externalUrl, download: false, newTab: true };
  const media = item.media;
  const key = media?.storageKey || media?.url;
  if (!media || !key) return null;
  switch ((media.mediaType || '').toLowerCase()) {
    case 'pdf': return { url: await pdfs.getSignedUrl(key), download: false, newTab: true };
    case 'image': return { url: await images.getSignedUrl(key), download: true, newTab: true };
    case 'video': return { url: await videos.getSignedUrl(key), download: false, newTab: true };
    default: return { url: media.url || key, download: true, newTab: true };
  }
};
